import { useHoveredRoomNoteStore } from "../../store/hoveredRoomNoteStore";
import { useRoomNoteDialogStore } from "../../store/roomNoteDialogStore";
import CanvasTooltip from "./CanvasTooltip";

// Renders the room note hover tooltip. Must live outside <Canvas>, see EditHandleTooltipOverlay.
const RoomNoteTooltipOverlay = () => {
    const { note, screenPosition } = useHoveredRoomNoteStore();
    const isDialogOpen = useRoomNoteDialogStore((s) => s.isOpen);

    if (!note || !screenPosition || isDialogOpen) return null;

    return <CanvasTooltip x={screenPosition.x} y={screenPosition.y} text={note} className="roomNoteTooltip" />;
};

export default RoomNoteTooltipOverlay;
